import { AutoLogout } from "@/setup/auto-logout";
import { logbookRoutesMESF, TimeService } from "@dexteel/mesf-core";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment-timezone";
import { type ReactNode } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { getScopedHome, isPathInScope } from "./navbar";
import { calendarRoutes } from "./routes/calendar.routes";
import { clipsRoutes } from "./routes/clips.routes";
// import { currentStatusRoutes } from "./routes/current-status.routes";
import { delayRoutes } from "./routes/delay.routes";
import { ganttRoutes, routeGantt } from "./routes/gantt.routes";
import { overviewRoutes } from "./routes/overviews.routes";
import { printersRoutes } from "./routes/printers.routes";
import { productsRoutes } from "./routes/products.routes";
import { reportsRoutes } from "./routes/reports.routes";
import { sawQualityChecksRoutes } from "./routes/saw-quality-checks.routes";
import { sawTabletRoutes } from "./routes/saw-tablet.routes";
import { tagStationRoutes } from "./routes/tag-station.routes";
import { weldlineSetupRoutes } from "./routes/weldline-setup.routes";
import { weldTestRoutes } from "./routes/weld-test.routes";
import { workOrdersRoutes } from "./routes/work-orders.routes";
import { useUserScope } from "./scope";

const timezone = TimeService.getInstance().getServerTimeZone();
moment.tz.setDefault(timezone);

const routeSections = [
	// { routes: currentStatusRoutes },
	{ routes: overviewRoutes },
	{ routes: delayRoutes },
	{ routes: ganttRoutes },
	{ routes: productsRoutes },
	{ routes: clipsRoutes },
	{ routes: weldlineSetupRoutes },
	{ routes: weldTestRoutes },
	{ routes: sawQualityChecksRoutes },
	{ routes: sawTabletRoutes },
	{ routes: tagStationRoutes },
	{ routes: reportsRoutes },
	{ routes: workOrdersRoutes },
	{ routes: calendarRoutes },
	{ routes: printersRoutes },
	{ routes: logbookRoutesMESF },
];

// Out of scope: redirect home
const ScopeGuard = ({ children }: { children: ReactNode }) => {
	const { pathname } = useLocation();
	const scope = useUserScope();
	if (scope.isLoading) return null;
	if (scope.isFull || isPathInScope(pathname, scope)) return <>{children}</>;
	return <Navigate to={getScopedHome(scope)} replace />;
};

const home = (
	<ScopeGuard>
		<Navigate to={routeGantt} replace />
	</ScopeGuard>
);

const CustomRoutes = () => (
	<AutoLogout>
		<LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
			<Routes>
				<Route path={"/"} element={home} />
				<Route path={"/home"} element={home} />

				{routeSections.map((section, index) => {
					return section.routes.map((route) => {
						return (
							<Route
								key={`route-${route.path}`}
								path={route.path}
								element={<ScopeGuard>{route.element}</ScopeGuard>}
							/>
						);
					});
				})}
			</Routes>
		</LocalizationProvider>
	</AutoLogout>
);

export { CustomRoutes };
